import { Grid, Typography, IconButton as iconButton } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';
import { LocalAirport, PinDrop } from '@mui/icons-material';

export const Input = styled(Grid)(
  {
    position: 'relative',
    maxWidth: '295px',
    width: '100%',
    borderRadius: '4px',
    padding: '5px 10px',
    margin: '0',
    marginBottom: '10px',
    border: '1px solid #BFBCB5',

    '&:focus-within': {
      border: '1px solid #006ee6',
    },
    '& > div > div > div > button': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  ({ error }) => ({
    border: error === 'true' ? '1px solid red' : '1px solid #BFBCB5',
  })
);

export const List = styled(Grid)({
  position: 'absolute',
  zIndex: '2',
  width: 'calc(100% + 4px)',
  maxHeight: '300px',
  backgroundColor: '#fff',
  overflow: 'scroll',
  border: '2px solid #DAD9D9',
  borderTop: 'none',
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
  left: '-2px',
  top: '60px',
  overflowX: 'hidden',

  [theme.breakpoints.down('sm')]: {
    maxWidth: '400px',
  },
});

export const SelectValue = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#DEDEDE',
  },
});

export const DestinationWrapper = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
});

export const LocationWrapper = styled(Grid)({
  display: 'flex',
});

export const Destination = styled(Typography)({
  marginLeft: '5px',
});

export const CountryName = styled(Typography)({
  marginLeft: '20px',
});

export const Airport = styled(Typography)({
  marginLeft: '5px',
});

export const Code = styled(Typography)({
  fontFamily: theme.typography.button.fontFamily,
});

export const IconButton = styled(iconButton)({}, ({ expand }) => ({
  transform: `rotate(${expand !== 'true' ? '180deg' : '0'})`,
}));

export const CityIcon = styled(PinDrop)({
  width: '18px',
});

export const AirportIcon = styled(LocalAirport)({
  transform: 'rotate(90deg)',
  width: '18px',
});
